<script>
import { api } from "@/state/services";
import Layout from "@/router/layouts/public";

export default {
  components: { Layout },
  data() {
    return {
      loading: true,
      iframeSrc: null,
      loadError: null,
      fetchSeq: 0,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.fetchIframeUrl();
      },
    },
  },
  methods: {
    fetchIframeUrl() {
      const seq = ++this.fetchSeq;
      this.loading = true;
      this.loadError = null;
      this.iframeSrc = null;

      api
        .get("telemedicina/iframe/rede/publico")
        .then((response) => {
          if (seq !== this.fetchSeq) return;
          if (response.data.status === "success" && response.data.url) {
            this.iframeSrc = response.data.url;
          } else {
            this.loading = false;
            this.loadError =
              (response.data && response.data.message) ||
              "Não foi possível carregar as consultas.";
          }
        })
        .catch(() => {
          if (seq !== this.fetchSeq) return;
          this.loading = false;
          this.loadError = "Falha na comunicação com o servidor. Tente novamente.";
        });
    },
    iframeLoaded() {
      this.loading = false;
    },
  },
};
</script>

<template>
  <Layout>
    <div class="rms-iframe-page">
      <b-alert v-if="loadError" class="flex-shrink-0" show variant="danger">{{ loadError }}</b-alert>

      <div class="card rms-iframe-card flex-fill">
        <div class="card-body rms-iframe-body">
          <transition name="fade">
            <div v-if="loading" class="rms-iframe-loading">
              <b-spinner variant="default" role="status"></b-spinner>
            </div>
          </transition>
          <iframe
            v-if="iframeSrc && !loadError"
            :src="iframeSrc"
            title=""
            class="rms-embed rounded"
            @load="iframeLoaded"
            referrerpolicy="same-origin"
          ></iframe>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.rms-iframe-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  min-height: calc(100vh - 11rem);
}

.rms-iframe-card {
  flex: 1 1 auto;
  min-height: 0;
}

.rms-iframe-body {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: min(22rem, 50vh);
  padding: 0;
}

.rms-iframe-loading {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  background: rgba(255, 255, 255, 0.85);
  border-radius: inherit;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

iframe.rms-embed {
  flex: 1 1 auto;
  align-self: stretch;
  width: 100%;
  height: 100%;
  min-height: 16rem;
  border: 0;
  display: block;
}
</style>
